/**
 * Web Vitals reporting utility.
 * Measures Core Web Vitals and reports them for performance monitoring.
 *
 * Thresholds (2024 standards):
 *   LCP  ≤ 2.5s  good  | ≤ 4.0s  needs-improvement  | > 4.0s  poor
 *   INP  ≤ 200ms good  | ≤ 500ms needs-improvement  | > 500ms poor
 *   CLS  ≤ 0.1   good  | ≤ 0.25  needs-improvement  | > 0.25  poor
 *   FCP  ≤ 1.8s  good  | ≤ 3.0s  needs-improvement  | > 3.0s  poor
 *   TTFB ≤ 800ms good  | ≤ 1.8s  needs-improvement  | > 1.8s  poor
 */

import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";
import type { Metric } from "web-vitals";

export type MetricReporter = (metric: Metric) => void;

function defaultReporter(metric: Metric): void {
  if (import.meta.env.DEV) {
    // In development, web vitals are available via browser DevTools Performance panel
    void metric; // TODO (Phase 5): forward to monitoring service
  }

  // TODO (Phase 5 observability): forward to monitoring service
  // Example: sendToAnalytics({ name: metric.name, value: metric.value, rating: metric.rating });
}

/**
 * Start collecting and reporting Core Web Vitals.
 * Call once after app mount in src/index.tsx.
 */
export function reportWebVitals(
  reporter: MetricReporter = defaultReporter,
): void {
  onCLS(reporter);
  onFCP(reporter);
  onINP(reporter);
  onLCP(reporter);
  onTTFB(reporter);
}
